module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAAQlBMVEUAAABbbYBba4Fba4Fba4Fba4Jba4Faa4JaaYBcbYBba4FaaoBba4Fba4FbbIBba4BaaoBaaoBgYIBZaYBca4Fba4HjQhbFAAAAFXRSTlMAHMrz67Tbe0QT5DDPmJdwYE4IXMNiE2vjAAAA0klEQVRIx+2UyxLCIBRDC6Uv+qBQ+f9fVdCJ1BkDLrQumk0pcwKXLFIdpU3r7RN+8TctxbiQPkqKMr5X/iHVl/BdZNs2frosPjQRbAYsOD/iYFw1Mn6tMToeU688TYTzjGvhac7p3kzyxQBkSIg8ETG8SZMEzY/hl9tkUPI8iw2FKGiACv/3NKlivjtDldGBBqt9Im2zhsCnjqzBv+grBqxPw2n4P0OoJcEhEYoJBhmqUDCDCH15gcH4IhkY3FTCTy6pwqmA31WpM7JmdC2Nq36kK8GmOGkXxyWsAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/supplychain/home.png
// module id = Utv9
// module chunks = 44